import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { getRemoteScreen } from "selectors";
import { ReduxState, RemoteScreenDocument } from "types";

export const useRemoteScreen = (remoteScreenIdFromProps?: string) => {
  const { meetId, remoteScreenId } = useParams<{
    meetId: string;
    remoteScreenId: string;
  }>();

  const props = React.useMemo(() => {
    return {
      match: {
        params: {
          meetId,
          remoteScreenId: remoteScreenIdFromProps ?? remoteScreenId,
        },
      },
    };
  }, [meetId, remoteScreenId, remoteScreenIdFromProps]);

  const remoteScreen = useSelector((state: ReduxState) =>
    getRemoteScreen(state, props),
  ) as RemoteScreenDocument | null;

  return remoteScreen;
};
